var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2357_63512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 6.43697C12.1164 6.43697 13.0836 5.44605 13.0836 4.21849C13.0836 2.99092 12.1164 2 10.9091 2C9.70182 2 8.72727 2.99092 8.72727 4.21849C8.72727 5.44605 9.70182 6.43697 10.9091 6.43697ZM5.09091 6.43697C6.29818 6.43697 7.26545 5.44605 7.26545 4.21849C7.26545 2.99092 6.29818 2 5.09091 2C3.88364 2 2.90909 2.99092 2.90909 4.21849C2.90909 5.44605 3.88364 6.43697 5.09091 6.43697ZM5.09091 7.91597C3.39636 7.91597 0 8.78118 0 10.5042V12.3529H10.1818V10.5042C10.1818 8.78118 6.78545 7.91597 5.09091 7.91597ZM10.9091 7.91597C10.6982 7.91597 10.4582 7.93076 10.2036 7.95294C11.0473 8.57412 11.6364 9.40975 11.6364 10.5042V12.3529H16V10.5042C16 8.78118 12.6036 7.91597 10.9091 7.91597Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2357_63512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon-group.a5f2adb75d8d79e00c256804e7941d0c.svg";
export { ForwardRef as ReactComponent };